import { Lock, RefreshCw, Truck, Wallet } from "lucide-react";
import { FREE_SHIPPING_SHORT } from "@/lib/shipping";

// Every badge states a verified fact only: the free-shipping threshold and the
// 30-day window come from the fulfilling store's policy, and PayPal is offered
// at checkout. No ship-from badge: no policy page names a warehouse or a state.
export const TrustBadges = () => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 py-3">
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <Lock className="h-3.5 w-3.5" />
        <span className="text-[11px] font-medium">Secure Checkout</span>
      </div>
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <RefreshCw className="h-3.5 w-3.5" />
        <span className="text-[11px] font-medium">30-Day Returns</span>
      </div>
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <Truck className="h-3.5 w-3.5" />
        <span className="text-[11px] font-medium">{FREE_SHIPPING_SHORT}</span>
      </div>
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <Wallet className="h-3.5 w-3.5" />
        <span className="text-[11px] font-medium">PayPal Accepted</span>
      </div>
    </div>
  );
};
